import { assignTokens } from '@sail/engine';
import { css, tokens } from '@sail/ui';
import { helmTokens } from './../../theme';
import { columnPaddingVariants } from './ColumnPaddingVariants';
import { copyTokens } from './tokens';
export const styles = {
    copy: css({
        display: 'grid',
        rowGap: `${copyTokens.rowGap}`
    }),
    copyIcon: css({
        minHeight: '40px',
        display: 'flex',
        alignItems: 'flex-end',
        marginBottom: `${copyTokens.rowGap}`
    }),
    copyCaption: css({
        color: `${helmTokens.color.accentColor}`,
        font: 'display.small'
    }),
    copyCtaContainer: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: `${tokens.space[200]}`,
        flexWrap: 'wrap'
    })
};
export const variants = {
    variant: {
        hero: {
            uses: [
                assignTokens(copyTokens, {
                    rowGap: helmTokens.layout.rowGap.large
                })
            ]
        },
        section: {
            uses: [
                assignTokens(copyTokens, {
                    columnPaddingRight: `${helmTokens.layout.columnPadding.xlarge}`
                })
            ]
        },
        subsection: {
            uses: [
                assignTokens(copyTokens, {
                    columnPaddingRight: `${helmTokens.layout.columnPadding.xlarge}`
                })
            ]
        },
        footer: {
            uses: [
                assignTokens(copyTokens, {
                    columnPaddingRight: `${helmTokens.layout.columnPadding.xlarge}`
                })
            ]
        },
        stat: {
            uses: [
                assignTokens(copyTokens, {
                    rowGap: helmTokens.layout.rowGap.normal,
                    paragraphGap: `${tokens.space[100]}`
                })
            ],
            subviews: {
                body: css({
                    font: 'body.medium'
                })
            }
        },
        detail: {
            uses: [
                assignTokens(copyTokens, {
                    rowGap: helmTokens.layout.rowGap.normal,
                    paragraphGap: `${tokens.space[100]}`
                })
            ],
            subviews: {
                body: css({
                    font: 'body.medium'
                })
            }
        }
    },
    ...columnPaddingVariants
};
export const globalBodyStyles = css.global({
    '.CopyBody img': {
        maxWidth: '100%'
    },
    '.CopyBody p + p': {
        marginTop: `${copyTokens.paragraphGap}`
    }
});

//# sourceMappingURL=CopyStyles.js.map